import React from 'react';
import PropTypes from 'prop-types';
import GroupsTable from './GroupsTable';
import EditGroupForm from './EditGroupForm';
import DeleteGroupConfirmationModal from './DeleteGroupConfirmationModal';

const GroupComponent = ({
  groupsData,
  showEditGroupRowDataModal,
  handleCloseForm,
  editGroup,
  selectedGroup,
  refreshGridGroupData,
  handleEditButtonClick,
  handleDismissErrorMessage,
  handleDeleteButtonClick,
  handleConfirmButtonClick,
  handleDeleteGroup,
  handleGridColumnStateChange,
  handleGridChanges,
  gridColumnState,
  gridCurrentState,
  handleSubmit,
  showDeleteGroupConfirmationModal,
  toggleShowDeleteGroupConfirmationModal,
  toggleShowEditGroupRowDataModal,
  validationMessage,
  clearValidationMessage,
  apiErrorMessage,
}) => {
  return (
    <div>
      <div>
        <GroupsTable
          groupsData={groupsData}
          handleGridChanges={handleGridChanges}
          gridColumnState={gridColumnState}
          handleGridColumnStateChange={handleGridColumnStateChange}
          refreshGridGroupData={refreshGridGroupData}
          handleDeleteButtonClick={handleDeleteButtonClick}
          handleEditButtonClick={handleEditButtonClick}
          handleDismissErrorMessage={handleDismissErrorMessage}
          showEditGroupRowDataModal={showEditGroupRowDataModal}
        />
      </div>

      <EditGroupForm
        editGroup={editGroup}
        handleCloseForm={handleCloseForm}
        initialValues={selectedGroup}
        onSubmit={handleSubmit}
        handleDismissErrorMessage={handleDismissErrorMessage}
        showEditGroupRowDataModal={showEditGroupRowDataModal}
        toggleShowEditGroupRowDataModal={toggleShowEditGroupRowDataModal}
        validationMessage={validationMessage}
        clearValidationMessage={clearValidationMessage}
      />

      <DeleteGroupConfirmationModal
        showDeleteGroupConfirmationModal={showDeleteGroupConfirmationModal}
        handleConfirm={handleConfirmButtonClick}
        toggleShowDeleteGroupConfirmationModal={
          toggleShowDeleteGroupConfirmationModal
        }
        gridCurrentState={gridCurrentState}
        initialValues={selectedGroup}
        apiErrorMessage={apiErrorMessage}
      />
    </div>
  );
};

GroupComponent.propTypes = {
  showEditGroupRowDataModal: PropTypes.bool.isRequired,
  handleCloseForm: PropTypes.func.isRequired,
  editGroup: PropTypes.func.isRequired,
  groupsData: PropTypes.arrayOf(
    PropTypes.shape({
      entityGroupID: PropTypes.number,
      entityGroupName: PropTypes.string,
      reitCount: PropTypes.number,
    })
  ),
  selectedGroup: PropTypes.object,
  refreshGridGroupData: PropTypes.func.isRequired,
  handleEditButtonClick: PropTypes.func.isRequired,
  handleDeleteButtonClick: PropTypes.func.isRequired,
  handleConfirmButtonClick: PropTypes.func.isRequired,
  handleDismissErrorMessage: PropTypes.func,
  handleGridColumnStateChange: PropTypes.func.isRequired,
  handleGridChanges: PropTypes.func.isRequired,
  gridColumnState: PropTypes.object.isRequired,
  gridCurrentState: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  showDeleteGroupConfirmationModal: PropTypes.bool.isRequired,
  toggleShowDeleteGroupConfirmationModal: PropTypes.func.isRequired,
  toggleShowEditGroupRowDataModal: PropTypes.func.isRequired,
};

export default GroupComponent;
